/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useContext, useState, useRef } from "react";
import {
    faAsterisk, faCheck, faClose, faDoorClosed, faDownload, faEye, faPencil, faPlus, faTrash, faTrashAlt, faXmark
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Row as RBRow, Pagination, Alert, Table, TableProps, Card, Col, Form, Spinner, Modal, Button
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { JCardProps, MensagemModalProps, PropsGeneric } from "../interfaces";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Document, Page, pdfjs } from 'react-pdf';
import { isMobile } from "react-device-detect";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface ButtonTrashProps {
    onClick: () => void,
    icon?: IconProp,
    title?: string,
    children?: React.ReactNode,
    className?: string;
}
interface SpanIconProps {
    count: number;
}

const JvCaption: React.FC<{ children?: React.ReactNode, className?: string }> = ({ children, className }) => {
    return (
        <caption className={`ps-2 fw-bold rounded-top-2 border-top border-start border-end  ${className ?? ""}`}>
            {children}
        </caption>)
}
const JCaption: React.FC<PropsGeneric> = ({ children, title, className }) => {
    return (
        <caption style={{ padding: '0', margin: '0', minHeight: '3rem' }}
            className={`row d-flex fw-bold justify-content-between 
                align-items-center rounded-top-2 border-top 
                border-start border-end ${className ?? ""}`
            } >
            <div className="col">
                {title ?? title}
            </div>
            <div className="col-auto">
                {children ?? children}
            </div>
        </caption>
    )
}

const SpanIcon: React.FC<SpanIconProps> = ({ count }) => {
    return (
        <span style={{ fontSize: '0.65rem' }}
            className={
                `top-0 start-100 translate-middle badge rounded-pill ${count === 0 ? 'bg-danger' : 'bg-success'}`
            }>
            {count}
        </span>
    )
}

const ButtonTrash: React.FC<ButtonTrashProps> = ({ onClick, icon = faTrashAlt, title = "Remover tudo" }) => {
    return (<div style={{ cursor: 'pointer' }} onClick={onClick} title={title}>
        <FontAwesomeIcon icon={icon} className="text-danger" />
    </div>)
}

const ButtonRemover: React.FC<ButtonTrashProps> = ({ onClick, icon = faTrash }) => {
    return (<div style={{ cursor: 'pointer' }} onClick={onClick} title="Remover registro">
        <FontAwesomeIcon icon={icon} className="text-danger" />
    </div>)
}

const ButtonVisualizar: React.FC<ButtonTrashProps> = (
    { children, onClick, icon = faEye, title = 'Visualizar', className }) => {
    return (<div style={{ cursor: 'pointer' }} onClick={onClick} title={title}>
        <FontAwesomeIcon icon={icon} className={className ?? 'text-primary'} /> {children}
    </div>)
}

const ButtonSelecionar: React.FC<ButtonTrashProps> = ({ onClick, icon = faCheck }) => {
    return (<div style={{ cursor: 'pointer' }} onClick={onClick} title="Selecionar">
        <FontAwesomeIcon icon={icon} className="text-success" />
    </div>)
}

const ButtonEditar: React.FC<ButtonTrashProps> = ({ onClick, icon = faPencil }) => {
    return (<div style={{ cursor: 'pointer' }} onClick={onClick} title="Editar">
        <FontAwesomeIcon icon={icon} className="text-success" />
    </div>)
}

const JRow: React.FC<PropsGeneric> = ({ children, className, style }) => {
    return (
        <RBRow className={`g-2 ${className ?? ''}`}>
            {children}
        </RBRow>
    )
}

const JFormGroup = (props: any) => {
    return (
        <Form.Group className={`mb-3 ${props.className ?? props.className}`}
            controlId={props.controlId} >
            {props.children}
        </Form.Group>
    )
}

const JPaginacao = (props: any | []) => {
    const { links } = props;
    const { meta } = props;

    return (<>
        {meta?.last_page > 1 && (
            <Pagination className={`my-1 `} >
                <Pagination.First disabled={meta.current_page === 1 ? true : false}
                    onClick={() => props.handlePageChange('1')} />
                <Pagination.Prev disabled={links.prev == null ? true : false}
                    onClick={() => props.handlePageChange(links.prev?.split('?')[1]?.split('=')[1])} />

                {meta.links?.map((item: any, index: number) => {
                    if (index > 0 && index + 1 < meta.links.length && item.active === true) {
                        return (
                            <Pagination.Item key={item.id}
                                active={item.active}
                                onClick={() =>
                                    !item.active && props.handlePageChange(item.url?.split('?')[1]?.split('=')[1])
                                }
                            >
                                {item.label}
                            </Pagination.Item>
                        )
                    }
                })}

                <Pagination.Next disabled={meta.current_page === meta.last_page ? true : false}
                    onClick={() => props.handlePageChange(links.next?.split('?')[1]?.split('=')[1])} />
                <Pagination.Last disabled={meta.current_page === meta.last_page ? true : false}
                    onClick={() => props.handlePageChange(meta.last_page)} />
            </Pagination>

        )}
    </>)
}

const JAlerta = (props: any) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            props.close(false)
        }, props.time || 5000);

        return () => clearTimeout(timer)
    }, [props.showError])

    return (
        <Alert className="mb-2" variant={props.variant}
            show={props.showError} onClose={() => props.close(false)}
            dismissible>
            <span>{props.messageError}</span>
        </Alert>
    )
}

const JAlertaErrorFormulario = (props: any) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            props.close(false)
        }, props.time || 5000);

        return () => clearTimeout(timer)
    }, [props.showError])

    return (
        <div role="alert"
            className={`fade mb-0 p-2 alert alert-danger alert-dismissible ${props.showError ? 'show' : ''}`}>
            <span>{props.messageError}</span>
        </div>
    )
}


const JTable: React.FC<TableProps> = ({ children, ...props }) => {
    return (

        <Table bordered striped className={`caption-top mb-1 ${props.className ?? ""}`} size="sm" {...props}  >
            {children}
        </Table>
    )
}
const JTr: React.FC<PropsGeneric> = ({ children, style, className }) => {
    const jstyle = style ? style : {}
    jstyle.verticalAlign = 'middle'
    return (

        <tr className={`${className ?? ''}`} style={jstyle}>
            {children}
        </tr>
    )
}

const JHeader = (props: any) => {
    const authContext = useContext(AuthContext);

    return (
        <Card.Header className="pb-0 ps-2">
            <JRow className="d-flex justify-content-center align-items-center">
                {props.urlCreate && (props.permissionCreate || authContext?.userLogado.is_superuser === 1 ||
                    authContext?.userLogado.is_staff === 1) && (

                        <Col sm="auto">
                            <Form.Group className="mb-2" >
                                <Link to={props.urlCreate} title="Adicionar [Insert]" id="btn-novo"
                                    className="btn btn-primary rounded-circle">
                                    <FontAwesomeIcon icon={faPlus} ></FontAwesomeIcon>
                                </Link>
                            </Form.Group>
                        </Col>
                    )}

                <Col sm="4">
                    {(props.permissionSearch || authContext?.userLogado.is_superuser === 1 ||
                        authContext?.userLogado.is_staff === 1) && (
                            <Form.Group className="mb-2" controlId="search">
                                <Form.Control type="search"
                                    value={props.search}
                                    placeholder="Procurar"
                                    aria-label="Procurar"
                                    onChange={(e) => props.setSearch(e.target.value)}
                                />
                            </Form.Group>
                        )}
                </Col>
                {props.children}
                <Col md={"auto"} className="ms-auto"  >
                    <Spinner style={{ float: 'right' }} variant="success" hidden={!props.showSpinner}
                        animation="border" role="status" />
                </Col>

            </JRow>
        </Card.Header>
    )
}

const JConfirmDelete = (props: any) => {
    return (
        <Modal show={props.showModal} onHide={props.handleCloseModal} backdrop='static' centered>
            <Modal.Header closeButton>
                <Modal.Title>Remover</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Confirma a remoção <strong>{props.selectedObject}</strong>?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleCloseModal}>
                    <FontAwesomeIcon icon={faXmark} /> Cancelar
                </Button>
                <Button variant="danger" onClick={() => props.handleDelete(props.id)}>
                    <FontAwesomeIcon icon={faTrash} /> Remover
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

const MensagemModal: React.FC<MensagemModalProps> = ({ show, handleClose, mensagem }) => {
    return (
        <Modal show={show} onHide={handleClose} centered backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title>Aviso</Modal.Title>
            </Modal.Header>

            <Modal.Body>{mensagem}</Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <FontAwesomeIcon icon={faClose} /> Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

const JCard: React.FC<JCardProps> = ({ children, className }) => {
    return (
        <Card className={`shadow-sm  ${className ?? 'card-primary card-outline'}`}>
            {children}
        </Card>
    )
}

const JCardBody: React.FC<PropsGeneric> = ({ children }) => {
    return (
        <Card.Body className="p-2">
            {children}
        </Card.Body>
    )
}

const JTHead: React.FC<PropsGeneric> = ({ children }) => {
    return (
        <thead className="">
            {children}
        </thead>
    )
}

const JTBody: React.FC<PropsGeneric> = ({ children }) => {
    return (
        <tbody className="table-group-divider">
            {children}
        </tbody>
    )
}

function MakeMessageError({ errors, field }: any) {
    return (
        <>
            {errors[field] && (
                <ul className="errorfield mb-1" id={`error_${field}`}>
                    <li className="text-danger">{errors[field][0]}</li>
                </ul>
            )}
        </>
    );
}

const CamposObrigatorios: React.FC = () => (
    <span className="text-danger fw-semibold" style={{ fontSize: '0.9rem' }}>
        (<FontAwesomeIcon size="2xs" icon={faAsterisk} />) Campos obrigatórios
    </span>
)

interface PdfModalProps {
    show: boolean;
    onHide: () => void;
    pdfUrl: string | null;
}

const PdfModal: React.FC<PdfModalProps> = ({ show, onHide, pdfUrl }) => {
    const [numPages, setNumPages] = useState<number>(0);
    const [containerWidth, setContainerWidth] = useState<number>(600);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {

        function updateWidth() {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.offsetWidth - 40);
            }
        }
        updateWidth();

        window.addEventListener("resize", updateWidth);
        return () => window.removeEventListener("resize", updateWidth);
    }, [show]);
    return (<>

        {isMobile ? (
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                centered
                backdrop="static"
                scrollable>
                <Modal.Header closeButton>
                    <Modal.Title className="h6">Pré-Visualização</Modal.Title>
                </Modal.Header>

                <Modal.Body
                    ref={containerRef}
                    style={{
                        overflowY: "auto",
                        textAlign: "center",
                    }}
                >
                    <Document file={pdfUrl} onLoadSuccess={(pdf) => setNumPages(pdf.numPages)} >
                        {Array.from(new Array(numPages), (_, index) => (
                            <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                                width={containerWidth}
                            />
                        ))}
                    </Document>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={onHide}
                    >
                        <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                    </Button>
                    <Button
                        as="a"
                        href={pdfUrl ?? undefined}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="primary"
                    >
                        <FontAwesomeIcon icon={faDownload} /> Baixar PDF
                    </Button>
                </Modal.Footer>
            </Modal>
        ) : (
            <Modal show={show} onHide={onHide} size="lg" centered backdrop='static' >
                <Modal.Header closeButton>
                    <Modal.Title className="h6">Pré-Visualização</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '80vh' }}>
                    {pdfUrl ? (
                        <iframe
                            src={pdfUrl}
                            title="PDF DAMDFE"
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <p>Carregando DAMDFE...</p>
                    )}
                </Modal.Body>
            </Modal>

        )}
    </>);

};

export {
    JRow,
    JPaginacao,
    JAlerta,
    JTable,
    JCaption,
    JHeader,
    JConfirmDelete,
    JCard,
    JCardBody,
    JTHead,
    JTBody,
    JTr,
    JFormGroup,
    MakeMessageError,
    JAlertaErrorFormulario,
    MensagemModal,
    CamposObrigatorios,
    PdfModal,
    ButtonTrash,
    ButtonRemover,
    ButtonVisualizar,
    ButtonSelecionar,
    ButtonEditar,
    JvCaption,
    SpanIcon
};
